import * as React from "react";
import * as _ from "underscore";
import Config from "../config";
import { DimKey } from "../domain/dimension";
import { I18nContext, useI18n } from "../domain/i18n";
import { OrgRating } from "../domain/organization";

export interface RatingProps {
  rating: number;
  // ^ Can be one of 1,2,3. See Config.ts.
  //
  // TODO: Defione a Rating type and use it instead of 'number'.
  //
  // TODO: The implementation of the component expects this to be absent.
  //       Can that still be the case? Is that logic still required?

  dimKey: undefined | DimKey;
  // ^ This can be explicitly set to 'undefined'! See for example on the DetailPage.
  // This controls what RatingIcon we show.

  showLabel?: boolean;
  // ^ This is used on the DetailPage.
}

export function Rating(props: RatingProps) {
  const I18n = useI18n();
  const { rating, dimKey, showLabel } = props;
  const rg = _.find(Config.ratingGroups, (d) => d.rating === rating);
  const labelText = rating != null ? (rg ? ratingGroupLabel(I18n, rg) : undefined) : undefined;

  return (
    <div className={"rating dim--" + dimKey} title={showLabel ? labelText : undefined}>
      {showLabel && <span className="rating__label">{labelText}</span>}
      <RatingIcon rating={rating} i={1} />
      <RatingIcon rating={rating} i={2} />
      <RatingIcon rating={rating} i={3} />
    </div>
  );
}

const RatingIcon = ({ rating, i }: { rating: number; i: number }) => (
  <i className={"icon " + (rating >= i ? "is-there" : "is-not-there")} />
);

export default Rating;

// -----------------------------------------------------------------------------

function ratingGroupLabel(
  I18n: I18nContext,
  rg: {
    name: string;
    rating: OrgRating;
  },
) {
  switch (rg.name) {
    case "top":
      return I18n.t("frontend.rating.groups.top");
    case "middle":
      return I18n.t("frontend.rating.groups.middle");
    case "low":
      return I18n.t("frontend.rating.groups.low");
    default:
      return "";
  }
}
